module.exports = "<ea-know-your-customer-administration-page></ea-know-your-customer-administration-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaAdministration/eaKnowYourCustomer/eaKnowYourCustomerAdministrationPage/eaKnowYourCustomerAdministrationPageModule.html
// module id = 955
// module chunks = 12